import Vue from 'vue';
import App from './App.vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from '@/router/index.js';
import store from "./store";
import cookies from 'vue-cookies';
import VueLazyload from 'vue-lazyload'

import hljs from 'highlight.js';
import 'github-markdown-css/github-markdown.css';

import 'mavon-editor/dist/css/index.css';

//忽略警告
// Vue.config.silent=true;

// 如果开启了typescript 需要额外安装 npm install @types/highlight.js
// 通过 import * as hljs from 'highlight.js' 引入
Vue.directive('highlight', function (el) {
  const blocks = el.querySelectorAll('pre code')
  blocks.forEach(block => {
    hljs.highlightBlock(block)
  })
})

// 图片懒加载配置
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png',
  loading: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
  attempt: 1
})

Vue.prototype.$token = "";
Vue.prototype.$cookies = cookies;
Vue.use(ElementUI);
Vue.use(store);
Vue.config.productionTip = false;


new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
